<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import '../src/assets/less/common.less';
@import '../src/assets/less/scrollbar.less';
#app {
  position: relative;
  font-family: 'MicrosoftYaHei';
  color: #02044A;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  overflow: hidden;

  /deep/ .el-table th.gutter{
    /*
    * 解决element-ui 表格篡位的问题
    */
    display: table-cell!important;
  }
}
</style>
